
import { Dialog } from '../../../components/ui/dialog'
import { Input } from '../../../components/ui/input'
import { Button } from '../../../components/ui/button'

const EditBoardModal = React.memo(({
  isOpen,
  onClose,
  onRename,
  newBoardName,
  setNewBoardName,
  isLoading,
  t
}) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={t('app:crm.t40')} // «Edit board»
    >
      <div className="space-y-4 my-6">
        {/* Use your Input in single-value mode */}
        <Input
          multi={false} // Disable tokens
          value={newBoardName}
          onChange={(e) => setNewBoardName(e.target.value)}
          placeholder={t('app:crm.t41')} // «Enter new board name»
          className="w-full"
        />

        {/* "Cancel" and "Save" buttons */}
        <div className="mt-4 flex justify-end space-x-2">
          <Button
            onClick={onClose}
            variant="outline" size="sm"
            disabled={isLoading}
          >
            {t('app:crm.t5')} {/* «Cancel» */}
          </Button>
          <Button
            onClick={onRename} size="sm"
            disabled={isLoading || !newBoardName.trim()}
          >
            {isLoading ? 'Loading...' : t('app:crm.t42')} {/* «Save» */}
          </Button>
        </div>
      </div>
    </Dialog>
  )
})

export default EditBoardModal
